import { ReactNode } from 'react';
import { Loading } from 'src/components';

export const LayoutContent = ({ loading, children }: { loading: boolean; children: ReactNode }) => {
  return loading ? <Loading flex kind="boat" /> : <>{children}</>;
};
